<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'teal'"
        :loading="loading"
        :disabled="disabled"
        :block="block"
        :text="$t('common.validate')"
        :icon="error ? 'mdi-alert' : 'mdi-content-save-cog'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnApply',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
        block: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>